export default "__VITE_ASSET__DOdaNxqb__"